import React from 'react';

import './styles.scss';
import {createClassName} from '../../util/utility';

interface RowProps extends React.HTMLProps<HTMLDivElement> {
  children?: any;
  className?: string;
}

function Row({children, className, ...rest}: RowProps) {
  const classes = createClassName('app-row', className);

  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
}

export default Row;
